export default __webpack_public_path__ + "static/media/background_service_mobile.dc769f31.png";